var makeString = require('./helper/makeString');

module.exports = function chars(str) {
  return makeString(str).split('');
};



//////////////////
// WEBPACK FOOTER
// ./~/underscore.string/chars.js
// module id = 110
// module chunks = 0